var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"no-border-padding",attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"d-flex",attrs:{"cols":"12","lg":"8","md":"10","sm":"12","xsm":"12"}},[_c('AggregateMultiChartCard',{attrs:{"config":_vm.config},on:{"update":_vm.onUpdate}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }